<template>
	<transition-group name="component-fade-slow" tag="div" class="alerts">
		<core-alert
			v-for="(alert, index) in alerts"
			:key="'_' + index"
			:type="alert.type"
			:index="index"
			:close="alert.close"
			:closes="alert.closes"
			:meta="alert.meta"
			:icon="alert.icon"
		>
			<!-- eslint-disable-next-line vue/no-v-html -->
			<div v-html="message(alert)"></div>
			<div
				v-if="showConnectButton(alert)"
				class="alert-connect-button"
				style="margin: 15px 0; display: inline-block"
			>
				<core-loading v-if="connectLoading" size="30px" style="max-width: 30px; margin: 0" />
				<core-button v-else color="blue" @click.prevent="handle"> Click Here To Reconnect Now </core-button>
			</div>
		</core-alert>
	</transition-group>
</template>

<script>
import get from 'lodash/get';
import { connect } from '@/components/mixins/connect';
export default {
	mixins: [connect],
	props: {
		alerts: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			// Props for the connect mixin.
			refreshAfter: true,
			disconnect: false,
		};
	},
	methods: {
		invalidCredentials(alert) {
			if (get(alert, 'meta.badCredentials')) {
				return true;
			}
			const search = 'authentication credentials given are invalid';
			const invalid = alert.message.indexOf(search);
			return -1 !== invalid;
		},
		showConnectButton(alert) {
			return 'error' === alert.type && this.invalidCredentials(alert);
		},
		message(alert) {
			const pre = 'Something went wrong while fetching data.';
			return alert.message.replace(pre, `<span class="omapi-alert__primary">${pre}</span>`);
		},
	},
};
</script>
